import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import {FormattedMessage} from "react-intl";
import InputFormGroup from "components/Form/InputFormGroup";
import {Button, Alert} from 'reactstrap';
import Loading from "components/Loading";
import Navigation from "components/Navigation";
import {Row, Col} from 'reactstrap';
import PhoneInputFormGroup from "components/Form/PhoneInputFormGroup";
import {countryCodeOptions} from "helpers/phone";

class Settings extends React.Component {
    static propTypes = {
        onSettingsSubmit: PropTypes.func.isRequired,
        onChangePasswordSubmit: PropTypes.func.isRequired,
        settingsStatus: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        }),
        changePasswordStatus: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        }),
        settingsLoading: PropTypes.bool,
        changePasswordLoading: PropTypes.bool,
        defaultValues: PropTypes.shape({
            name: PropTypes.string,
            surname: PropTypes.string,
            phone: PropTypes.string,
        }),
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.setState({
            settingsValid: false,
            changePasswordValid: false,
        })
    }

    render() {
        const {
            defaultValues,
            onSettingsSubmit,
            onChangePasswordSubmit,
            settingsStatus,
            settingsLoading,
            changePasswordLoading,
            changePasswordStatus,
            operator,
            onOnlineChange,
            onLogout
        } = this.props;

        return (
            <Row>
                <Col md={4} xl={3} className="col-sidebar">
                    <Navigation user={operator} onOnlineChange={onOnlineChange} onLogout={onLogout}/>
                </Col>
                <Col md={8} xl={9}>
                    <h2 className="mb-3 font-weight-normal text-center pt-3">
                        <FormattedMessage id="settings.page_title" defaultMessage="Settings"/>
                    </h2>

                    <Formsy onValidSubmit={onSettingsSubmit} onValid={() => this.setState({settingsValid: true})}
                            onInvalid={() => this.setState({settingsValid: false})} className="form">
                        <InputFormGroup type="text" name="name" id="name" required value={defaultValues.name}
                                        label={(
                                            <FormattedMessage id="registration.name_label"
                                                              defaultMessage="Given name"/>)}
                        />
                        <InputFormGroup type="text" name="surname" id="surname" required value={defaultValues.surname}
                                        label={(
                                            <FormattedMessage id="registration.surname_label"
                                                              defaultMessage="Surname"/>)}
                        />
                        <PhoneInputFormGroup type="text" name="phone" id="phone" required
                                             value={defaultValues.phone.replace('00', '+')}
                                             countryOptions={countryCodeOptions}
                                             validations={{
                                                 matchRegexp: /^(00|\+)420\d{9}$/,
                                             }}
                                             validationErrors={{
                                                 matchRegexp: (<FormattedMessage id="form.error.is_phone_number"
                                                                                 defaultMessage="This is not valid phone number"/>)
                                             }}
                                             label={(<FormattedMessage id="registration.phone_label"
                                                                       defaultMessage="Phone number"/>)}
                        />
                        <InputFormGroup type="text" name="identification_number" disabled
                                        value={defaultValues.data.identNum}
                                        label={(<FormattedMessage id="registration.ident_num_label"
                                                                  defaultMessage="Identification number"/>)}/>
                        <InputFormGroup type="text" name="identification_number" disabled
                                        value={defaultValues.data.businessName}
                                        label={(<FormattedMessage id="registration.business_name_label"
                                                                  defaultMessage="Business name"/>)}/>
                        <InputFormGroup type="text" name="business_address" disabled
                                        value={defaultValues.data.businessAddress}
                                        label={(<FormattedMessage id="registration.business_address_label"
                                                                  defaultMessage="Business address"/>)}/>
                        <InputFormGroup type="text" name="correspondence_address" disabled
                                        value={defaultValues.data.correspondenceAddress}
                                        label={(<FormattedMessage id="registration.correspondence_address_label"
                                                                  defaultMessage="Correspondence address"/>)}/>
                        <InputFormGroup type="checkbox" name="correspondence_address" disabled
                                        checked={defaultValues.data.vatPayer}
                                        label={(<FormattedMessage id="registration.vat_payer_label"
                                                                  defaultMessage="VAT payer"/>)}/>
                        <InputFormGroup type="text" name="tax_identification_number" disabled
                                        value={defaultValues.data.taxIdentificationNumber}
                                        label={(<FormattedMessage id="registration.tin_label"
                                                                  defaultMessage="Tax identification number"/>)}/>
                        <InputFormGroup type="text" name="bank_account_number" disabled
                                        value={defaultValues.data.bankAccountNumber}
                                        label={(<FormattedMessage id="registration.ban_label"
                                                                  defaultMessage="Bank account number"/>)}/>
                        <InputFormGroup type="text" name="website" disabled value={defaultValues.data.website}
                                        label={(<FormattedMessage id="registration.www_label"
                                                                  defaultMessage="Website"/>)}/>

                        {settingsStatus &&
                        <Alert color={settingsStatus.type}>
                            {settingsStatus.message}
                        </Alert>
                        }

                        <Button disabled={!this.state.settingsValid || settingsLoading} type="submit"
                                className="btn-clickable" block>
                            {settingsLoading &&
                            <span className="pr-3">
                            <Loading inline small/>
                        </span>
                            }
                            <FormattedMessage id="settings.form.submit" defaultMessage="Edit account"/>
                        </Button>
                    </Formsy>

                    <Formsy onValidSubmit={onChangePasswordSubmit}
                            onValid={() => this.setState({changePasswordValid: true})}
                            onInvalid={() => this.setState({changePasswordValid: false})} className="form">
                        <InputFormGroup type="password" name="oldPassword" id="oldPassword" required
                                        label={(
                                            <FormattedMessage id="settings.old_password_label"
                                                              defaultMessage="Password"/>)}
                        />
                        <InputFormGroup type="password" name="password" id="password" validations="minLength:8" required
                                        validationErrors={{
                                            minLength: (<FormattedMessage id="form.error.password_min_length"
                                                                          defaultMessage="Your password must have at least {limit, plural, one {# character} other {# characters}}"
                                                                          values={{limit: 8}}/>)
                                        }}
                                        label={(
                                            <FormattedMessage id="settings.new_password_label"
                                                              defaultMessage="Password"/>)}
                        />
                        <InputFormGroup type="password" name="passwordConfirm" id="passwordConfirm" required
                                        validations="equalsField:password"
                                        validationErrors={{
                                            equalsField: (<FormattedMessage id="form.error.password_match"
                                                                            defaultMessage="Passwords does not match"/>)
                                        }}
                                        label={(<FormattedMessage id="settings.new_password_confirmation_label"
                                                                  defaultMessage="Repeat password"/>)}
                        />

                        {changePasswordStatus &&
                        <Alert color={changePasswordStatus.type}>
                            {changePasswordStatus.message}
                        </Alert>
                        }

                        <Button disabled={!this.state.changePasswordValid || changePasswordLoading} type="submit"
                                className="btn-clickable" block>
                            {changePasswordLoading &&
                            <span className="pr-3">
                            <Loading inline small/>
                        </span>
                            }
                            <FormattedMessage id="settings.form.change_password" defaultMessage="Change password"/>
                        </Button>
                    </Formsy>
                </Col>
            </Row>
        )
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/containers/Settings/Settings.jsx